<template>
  <div class="user2-container">
     <div class="tc">
        <div class="news" @click="goNews()" v-if="gotoNews">
          <el-badge :is-dot="hasDot" class="item">
            <img :src="news" alt="" srcset="">
          </el-badge>
        </div>
        <div class="userImg">
          <img :src="userImage" alt @click.stop="actUsers(1)" />
        </div>
        <div class="userData" :class="{userDataOn:actUser && (hideOn == 1)}">
          <div class="hoverBd">{{ nickName }}</div>
          <div class="hoverBd" @click="loginOut">退出登录</div>
        </div>
     </div>
  </div>
</template>

<script>
  import { outLogin } from '@/js/utils'
  const news = require("@/assets/message.png");
  export default {
    data() {
      return {
        actUser: false,
        hideOn: -1,
        news: news,
      };
    },
    props: {
      setLo: {
        type: Boolean,
        required: false,
        default: false
      },
      gotoNews: {
        type: Boolean,
        required: false,
        default: false
      },
      hasDot: {
        type: Boolean,
        required: false,
        default: false
      }
    },


    methods: {
      toLogin() {
        var toURL = process.env.SSO_API
        var redirect = encodeURIComponent(process.env.SSO_REDIRECT)
        location.href = toURL + `?redirect=${ redirect }`
      },
      actUsers(e) {
        this.hideOn = e;
        this.actUser = !this.actUser;
      },
      loginOut() {
        outLogin.call(this)
        if (this.setLo) localStorage.setItem('Lo', 2)
      },
      goNews(){
        this.$router.push({ path: "/news" });
      }
    },
    computed: {
      nickName() {
        return this.$store.state.nickName;
      },
      userImage() {
        return this.$store.state.userImage;
      }
    },
    mounted() {
      //阻止冒泡事件
      document.addEventListener("click", e => {
        if (e.target.className != "userData") {
          this.actUser = false;
        }
      })
    },
  };
</script>

<style scoped lang="less">
  .user2-container {
    width: 100%;
    height: 100%;

    .guest {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      color: #fff;

      .login {
        color: #fff;
        text-decoration: none;
        line-height: 50px;
        cursor: pointer;
      }
    }

    .user {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      font-size: 18px;
      color: #fff;

      .img {
        width: 18px;
        height: 18px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .logout {
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user2.vue